/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ author: NonNullable<unknown> }} Deck_By_AuthorInputs */



/**
* | output |
* | --- |
* | "by {author}" |
*
* @param {Deck_By_AuthorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_by_author = /** @type {((inputs: Deck_By_AuthorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_By_AuthorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`par ${i?.author}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`por ${i?.author}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`por ${i?.author}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`di ${i?.author}`)
	return /** @type {LocalizedString} */ (`by ${i?.author}`)
});